interface Props {
  color?: string
  width?: number
  height?: number
}

export const SendToBackIcon = ({ color = '#6F6F6F', width = 21, height = 20 }: Props) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.4502 0C9.00239 0.000104788 9.4502 0.44778 9.4502 1V3.1748H14.75C15.5783 3.17491 16.2499 3.84653 16.25 4.6748V11.5498H20C20.5522 11.5498 20.9999 11.9976 21 12.5498V18.9502C20.9999 19.5024 20.5522 19.9502 20 19.9502H12.5498C11.9977 19.9501 11.5499 19.5023 11.5498 18.9502V15.7246H5.2002C4.37177 15.7246 3.7002 15.053 3.7002 14.2246V8.40039H1C0.447846 8.40039 0.000211266 7.9525 0 7.40039V1C7.85384e-08 0.447715 0.447715 2.02981e-08 1 0H8.4502ZM9.4502 7.40039C9.44998 7.95243 9.00226 8.40029 8.4502 8.40039H4.7002V14.2246C4.7002 14.5008 4.92405 14.7246 5.2002 14.7246H11.5498V12.5498C11.5499 11.9977 11.9977 11.5499 12.5498 11.5498H15.25V4.6748C15.2499 4.39882 15.026 4.17491 14.75 4.1748H9.4502V7.40039Z"
        fill={color}
      />
    </svg>
  )
}
